import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';

const LOG_PREFIX = '[ws-locations-data][PubSub]';

/**
 * Publishes an event through the global DDC pubsub system(DDC-WebPlatform/ddc-pubsub)
 * @param {string} topic - Event topic (e.g., 'ws-locations-data/locations')
 * @param {...any} params - Data to publish with the event
 */
export const publishEvent = (topic, ...params) => {
	if (isBrowser && window?.DDC?.pubsub) {
		logger.debug(`${LOG_PREFIX} Publishing event:`, topic, params);
		window.DDC.pubsub.publish(topic, ...params);
	} else {
		logger.warn(`${LOG_PREFIX} Cannot publish - pubsub not available:`, {
			topic,
			isBrowser,
			hasPubsub: !!(typeof window !== 'undefined' && window.DDC?.pubsub)
		});
	}
};
